import { css, SimpleInterpolation } from 'styled-components';

const breakpoints = {
  xs: '375px',
  sm: '768px',
  md: '1024px',
  lg: '1280px',
  xl: '1920px',
  values: {
    xs: 375,
    sm: 768,
    md: 1024,
    lg: 1280,
    xl: 1920
  }
};

type TemplateTag = (
  strings: TemplateStringsArray,
  ...interpolations: SimpleInterpolation[]
) => string;

type Media = {
  xs: TemplateTag;
  sm: TemplateTag;
  md: TemplateTag;
  lg: TemplateTag;
  xl: TemplateTag;
};

const media: Media = Object.keys(breakpoints.values).reduce(
  (acc, label) => {
    acc[label] = (
      strings: TemplateStringsArray,
      ...interpolations: SimpleInterpolation[]
    ) => css`
      @media print, (min-width: ${breakpoints.values[label]}px) {
        ${css(strings, ...interpolations)};
      }
    `;

    return acc;
  },
  {} as Media
);

export { breakpoints, media };
